<template>
  <v-form v-model="valid" ref="form">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          :rules="[$rules.required]"
          ref="name"
          v-model="name"
          label="Họ và tên"
          placeholder="Nhập tên giáo viên"
          required
          dense
          outlined
        ></v-text-field>
        <v-text-field
          ref="phone"
          v-model="phone"
          label="Số điện thoại"
          placeholder="Nhập số điện thoại"
          required
          dense
          outlined
          :rules="[$rules.phone]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          :rules="[$rules.required]"
          ref="gender"
          v-model="gender"
          label="Giới tính"
          required
          dense
          outlined
          :items="genderOptions"
          item-text="text"
          item-value="value"
        ></v-select>
        <date-selector
          :rules="[$rules.required]"
          ref="dob"
          v-model="dob"
          label="Ngày sinh"
          :date="transformDateForDatePicker(dob)"
          @change="onChangeDob"
        ></date-selector>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          :rules="[$rules.required]"
          ref="email"
          v-model="email"
          label="Email Giáo Viên"
          placeholder="Nhập email giáo viên"
          dense
          outlined
        ></v-text-field>
        <v-text-field
          type="url"
          ref="facebook"
          :rules="[$rules.url]"
          v-model="facebook"
          label="Facebook Giáo Viên"
          placeholder="Nhập facebook link"
          dense
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import moment from 'moment'
import { genderOptions, transformDateForDatePicker } from '../../../helpers'
import DateSelector from '@/components/basic/DateSelector.vue'

export default {
  props: {
    teacher: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  components: { DateSelector },
  data: () => ({
    valid: true,
    name: '',
    email: '',
    parentEmail: '',
    // school: '',
    notes: '',
    phone: '',
    facebook: '',
    gender: '',
    dob: ''
  }),
  computed: {
    genderOptions
  },
  created() {
    this.reset()
  },
  methods: {
    transformDateForDatePicker,
    onChangeDob(value) {
      this.dob = moment(value, 'YYYY-MM-DD').startOf('day').toISOString()
    },
    validate() {
      return this.$refs.form.validate()
    },
    reset() {
      this.name = this.teacher.name
      this.email = this.teacher.email
      this.phone = this.teacher.phone
      this.facebook = this.teacher.facebook
      // this.parentEmail = ''
      // this.school = ''
      // this.notes = ''
      this.gender = this.teacher.gender
      this.dob = this.teacher.dob
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      return {
        name: this.name || null,
        email: this.email || null,
        phone: this.phone || null,
        facebook: this.facebook || null,
        dob: this.dob,
        gender: this.gender,
        // school: this.school,
        notes: this.notes || null
      }
    }
  },
  watch: {
    teacher(teacher) {
      this.reset()
    }
  }
}
</script>

<style>
input {
  margin: 8px 0px;
}
</style>
